import { IPaginationParams } from '../../types';
import { api } from '../../DefaultService';
import {
  IRecognitionGroupCreateProps,
  IRecognitionGroupFilterParams,
  IRecognitionGroupGetAllParams,
  IRecognitionGroupProps,
  IRecognitionGroupSimpleProps,
  IRecognitionGroupUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/groups';

export const createRecognitionGroupAsync = async (
  data: IRecognitionGroupCreateProps,
): Promise<IRecognitionGroupProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateRecognitionGroupAsync = async ({
  id,
  data,
}: IRecognitionGroupUpdateParams): Promise<IRecognitionGroupProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteRecognitionGroupAsync = async (id: number) => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getRecognitionGroupByIdAsync = async (
  id: number,
): Promise<IRecognitionGroupProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionGroupByLicenseAsync = async ({
  pagination,
  filter,
}: IRecognitionGroupGetAllParams): Promise<IRecognitionGroupSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionGroupByLicenseCountAsync = async (
  filter?: IRecognitionGroupFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
